import { YardPropertiesService } from './../../../../yard-properties.service';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppClientConfigurationService, DialogService, Identity, ResponseMessage, ResponseStatus, TranslationService } from '@sdbn/common';
import { Transport } from '../../model/supplementary-equipment-handout';
import { SupplementaryEquipmentHandoutService } from '../../service/supplementary-equipment-handout.service';

@Component({
    selector: 'app-supplementary-equipment-handout',
    templateUrl: './supplementary-equipment-handout.component.html',
    styleUrls: ['./supplementary-equipment-handout.component.scss'],
    standalone: false
})
export class SupplementaryEquipmentHandoutComponent implements OnInit {

  transport = new Transport();
  isLoading = false;

  identity;

  formGroup = new UntypedFormGroup({});

  responseMessages = new Array<ResponseMessage>();

  forceConfirmSupplementaryEquipment = false;

  constructor(
    public dialogRef: MatDialogRef<SupplementaryEquipmentHandoutComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private seService: SupplementaryEquipmentHandoutService,
    public configurationService: AppClientConfigurationService,
    public translationService: TranslationService,
    public dialogService: DialogService,
    public yardPropertiesService: YardPropertiesService) {

    this.isLoading = true;
    this.identity = new Identity();
    this.identity.id = data.transportId;

    //this.forceConfirmSupplementaryEquipment = this.configurationService.getPropertyValue('tmc-yard.supplementaryequipment.show-no-handout', 'true') === 'true'
    this.forceConfirmSupplementaryEquipment = this.yardPropertiesService.isShowNoHandoutEnabled()
  }

  ngOnInit() {
    this.seService.getTransport(this.identity).subscribe(response => {
      this.transport = response;
      this.isLoading = false;
      this.setupForm();
    }, error => {
      console.error(error);
      this.isLoading = false;
    });
  }

  private setupForm() {
    this.transport.supplementaryEquipments.forEach(se => {
      const equipmentFormGroup = new UntypedFormGroup({
        selected: new UntypedFormControl(se.selected ?? false),
        identifier: new UntypedFormControl(se.selectedIdentifier, Validators.required),
      })
      this.formGroup.addControl(se.equipmentTypeId, equipmentFormGroup);
      if ((se.selected ?? false) !== true) { // initialer Status des Formfields
        equipmentFormGroup.controls.identifier.disable();
      }
    });

    this.formGroup.valueChanges.subscribe(values => {
      this.transport.supplementaryEquipments.forEach(se => {
        se.selected = values[se.equipmentTypeId].selected;
        // Unklar, warum identifier nicht in 'values' enthalten ist.
        se.selectedIdentifier = (this.formGroup.get(se.equipmentTypeId) as UntypedFormGroup).controls.identifier.value;

        if (se.selected && se.availableIdentifiers.length > 0) {
          this.formGroup.get([se.equipmentTypeId, 'identifier'])?.enable({onlySelf: true, emitEvent: false});
        }

      });
    });
  }

  isSaveDisabled(): boolean {
    if (this.isLoading) {
      return true;
    }
    // wenn keine "Bestätigung Begleitmittel nötig" konfiguriert
    if (!this.forceConfirmSupplementaryEquipment) {
      // prüfung auf eingabe ungültiger werte
      for (const se of this.transport.supplementaryEquipments) {
        if (se.selected) {
          if (se.availableIdentifiers != null && se.availableIdentifiers.length > 0 && se.selectedIdentifier == null) {
            return true;
          }
        }
      }
    }

    // SE nur prüfen wenn flag nicht gesetzt
    if (!this.transport.noSupplementaryEquipmentHandout) {
      // kein check, wenn es keine SE gibt
      if (this.transport.supplementaryEquipments.length === 0) {
        return false;
      }

      let validCount = 0;
      for (const se of this.transport.supplementaryEquipments) {
        if (se.selected) {
          if (se.availableIdentifiers != null && se.availableIdentifiers.length > 0 && se.selectedIdentifier == null) {
            return true;
          } else {
            validCount += 1;
          }
        }
      }
      return validCount === 0;
    }
    return false;
  }

  cancel() {
    this.dialogRef.close({ status: 'cancelled' });
  }

  save() {

    this.responseMessages = [];

    this.isLoading = true;
    this.seService.saveTransport(this.transport).subscribe(response => {
      if (response.status === ResponseStatus.SUCCESS) {

        // Mehrfachausgabe von Smartphone oder Pager bestätigen
        if (response.confirmMultipleSmartphones || response.confirmMultiplePagers) {

          this.dialogService.showConfirm().afterClosed().subscribe(confirm => {
            if (confirm) {
              // und speichern mit confirmed flag erneut ausführen
              this.transport.saveMultipleConfirmed = true;
              this.save();
            }
          });

        } else {
          this.dialogRef.close({ status: 'success' });
        }

      } else {
        this.responseMessages = response.responseMessages;
      }
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
      console.log(error);
    });
  }

  isNoSupplementaryEquipmentHandoutDisabled(): boolean {

    if (this.isLoading) {
      return true;
    }

    if (this.transport.supplementaryEquipmentHandoutHappened === true) {
      return true;
    }
    if (this.transport.supplementaryEquipments != null &&
      this.transport.supplementaryEquipments.length > 0 && this.transport.supplementaryEquipments.some(se => se.selected)) {
      return true;
    }
    return false;
  }

  isFormReadonly() {
    return this.isLoading;
  }

  isNoSupplementaryEquipmentHandoutSelected(): boolean {
    return this.transport.noSupplementaryEquipmentHandout === true;
  }
}
